import Vue from 'vue';
import accounting from 'accounting';

const defaults = {
  currency: {
    symbol: '€',
    format: '%s\u2007%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
    decimal: ',',  // decimal point separator
    thousand: '.',  // thousands separator
    precision: 2   // decimal places
  },
  number: {
    decimal: ',',
    thousand: '.',
    precision: 2,
  }
};

accounting.settings = {
  currency: defaults.currency,
  number: defaults.number,
};

Vue.filter('money', price => accounting.formatMoney(price));
